import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "299",
  "slug": "spot-south-korea-from-satellite-imagery",
  "title": "How to Recognise South Korea in Satellite Images",
  "excerpt": "South Korea occupies the southern part of the Korean Peninsula.",
  "date": "2026-04-15",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/south-korea.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "South Korea occupies the southern part of the Korean Peninsula. Much of the interior is mountainous, with larger lowlands along parts of the west. The west and south coasts contain many inlets and islands; the east coast is generally more continuous."
    },
    {
      "type": "heading",
      "text": "Mountains beside cultivated lowlands"
    },
    {
      "type": "paragraph",
      "text": "Compare the west coast around the Han River estuary with a section of the east coast. Notice the difference in the amount of flat coastal land."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Japan also combines wooded mountains, dense urban areas, and cultivated valley floors. Apartment blocks or rice fields do not settle the location. Use the coastline and the shape of a major river plain for context."
    }
  ],
  "imageAlt": "South Korea regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
